import * as z from 'zod';

import { WorkoutPlanId } from '../../../BrandedIds';
import { RepaymentPlanCancellationReason } from '../../../loan/WorkoutPlan';
import { BaseLoanEvent } from '../../BaseLoanEvent';

export const CancelRepaymentWorkoutPlanEvent = BaseLoanEvent.extend({
  type: z.literal('cancelRepaymentWorkoutPlan'),
  workoutPlanId: WorkoutPlanId,
  reason: RepaymentPlanCancellationReason,
  terminationDate: z.date(),
});
export type CancelRepaymentWorkoutPlanEvent = z.infer<typeof CancelRepaymentWorkoutPlanEvent>;
